import { render } from "./ReportCriterionAutocomplete.vue?vue&type=template&id=a4a7011c&scoped=true"
import script from "./ReportCriterionAutocomplete.vue?vue&type=script&lang=js"
export * from "./ReportCriterionAutocomplete.vue?vue&type=script&lang=js"

import "./ReportCriterionAutocomplete.vue?vue&type=style&index=0&id=a4a7011c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4a7011c"]])

export default __exports__